import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { NgxPermissionsService, NgxRolesObject, NgxRolesService } from 'ngx-permissions';
import { PerfilEnum } from './permissoes-acesso';
import { AuthenticationService } from './authentication.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AppSharedDataService } from 'src/app/app-shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {
  constructor(
    private roleService: NgxRolesService,
    private permissionService: NgxPermissionsService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private authenticationService: AuthenticationService
  ) { }

  permissoesLivres!: any[];
  existePermissaoGeral!: boolean;

  async canActivate(
    next: ActivatedRouteSnapshot
  ): Promise<boolean> {

    const userData = <any>JSON.parse(this.localStorageService.getItem('currentUser'));

    if (userData) {
      this.authenticationService.addRolesAcesso(userData);
      const perfilUsuario = userData?.grupo?.descricao;
      const perfilLowerCase = perfilUsuario?.toLowerCase();
      const perfilUsuarioSemCaracteres = perfilLowerCase?.replace(/[ç]/g, 'c').replace(/[ã]/g, 'a').toUpperCase();

      this.permissoesLivres = [PerfilEnum.Administracao];
      this.existePermissaoGeral = this.permissoesLivres.some(perm => perm === perfilUsuarioSemCaracteres);

      if (!this.existePermissaoGeral) {
        const requiredPermissions = next.data['permissions']?.requiredPermissions;
        const getUserRolePermissions = this.roleService.getRoles();

        const functionsIsValid = <any>getUserRolePermissions[perfilUsuario]?.validationFunction;

        const permissionsArray = Array.isArray(functionsIsValid)
          ? functionsIsValid.map((item: any) => ({ objeto: item.objeto, permissao: item.permissao }))
          : [{ objeto: functionsIsValid.objeto, permissao: functionsIsValid.permissao }];

        const paginasComAcesso = permissionsArray.map((item: any) => item.objeto);

        const hasValidPermissions = requiredPermissions?.every((role: NgxRolesObject) => {
          const roleObjeto = permissionsArray.filter((item: any) => item.objeto === role);
          this.addPermission(roleObjeto, paginasComAcesso);

          if (roleObjeto.length) {
            const specificPermissions = next.data['permissions'].specificPermissions;
            const hasOnlySpecificPermissions = specificPermissions?.some((permission: NgxRolesObject) => {
              return roleObjeto.some((item: any) => item.permissao === permission);
            });
            return hasOnlySpecificPermissions;
          }
          return false;
        });

        if (!hasValidPermissions) {
          this.router.navigate(['/acesso-nao-permitido']);
        }
        return hasValidPermissions === undefined ? true : hasValidPermissions;
      } else {
        this.addPermission();
        return true;
      }
    }
    return true;
  }

  addPermission(listaDePermissoesPagina?: any, paginasComAcesso?: any) {
    if (!this.existePermissaoGeral) {
      const permissoesPagina = listaDePermissoesPagina.map((role: { permissao: any; }) => role.permissao);
      const paginasComAcessoSemRepetir = [...new Set(paginasComAcesso)]
      const paginasAcessoEPermissaoPaginaAtual = <any>paginasComAcessoSemRepetir.concat(permissoesPagina);
      this.permissionService.loadPermissions(paginasAcessoEPermissaoPaginaAtual);
      this.localStorageService.setItem('permissions', JSON.stringify(paginasAcessoEPermissaoPaginaAtual))
    }
    else {
      this.permissionService.loadPermissions(this.permissoesLivres);
      this.localStorageService.setItem('permissions', JSON.stringify(this.permissoesLivres))
    }
  }
}
